import React from 'react'
import Popup from '../../../../popup/Popup'
import { ReactComponent as DrawIcon } from "../../../../images/icons/ico-draw-gray.svg"

export default class DrawProposalPopup extends React.Component {

  render() {
    return (
      <Popup
        icon={<DrawIcon />}
        title="Draw"
        text="Are you sure you want to propose a draw?"
        buttons={[
          { text: 'Back to game' },
          { text: 'Propose draw', handler: this.props.onProposeDraw },
        ]}
        onClose={this.props.onClose}
      />
    )
  }
}
